import { NextPage } from 'next';
import { ArticlePage, CategoryPage } from 'src/components/pages';
import { ISupportPageData, SUPPORT_PAGE_TYPE } from 'src/core/types';
import { getArticleOrCategoryPageProps } from 'src/helpers/config/getArticleOrCategoryPageProps';

const MobileArticlePage: NextPage<ISupportPageData> = ({ data }: ISupportPageData) => {
  const PageComponent = data.type === SUPPORT_PAGE_TYPE.category ? CategoryPage : ArticlePage;
  return <PageComponent data={data} />;
};

export const getServerSideProps = getArticleOrCategoryPageProps;

export default MobileArticlePage;
